



















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Comment } from '@/types';

@Component
export default class CreateUserModal extends Vue {

    data: object = {
        name: '',
        username: '',
        password: '',
        password_confirmation: '',
    };

    showModal() {
        (this.$refs.modal as any).show();
    }

    saveModal() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                (this.$refs.modal as any).hide();
                this.save();
            }
        });
    }

    @Emit()
    save() {
        return this.data;
    }

    validateField(name: string) {
        if (this.veeFields[name] && (this.veeFields[name].dirty || this.veeFields[name].validated)) {
          return !this.errors.has(name);
        }
        return null;
    }
}
